<!--
  La paginas para administrar Formularios
-->
<div class="page" id="record-def-collection-page">
    <div class="action-bar dark-bg with-tabs">
            <div class="title">Formularios</div>
            <div class="tabs">
                <a class="tab" href="#formularios?estado=A">Activos</a>
                <a class="tab" href="#formularios?estado=E">En edición</a>
                <a class="tab" href="#formularios?estado=I">Inactivos</a>
                <a class="tab" href="#formularios?estado=X">Eliminados</a>
                <a class="tab" href="#formularios?estado=*">Todos</a>
            </div>
            <div class="actions-set">
                <a class="action-btn back" href="#home"></a>
                <a class="action-btn search" href="#"></a>
                <a class="action-btn add" href="#nuevo-formulario">Agregar un nuevo formulario</a>
                <a class="action-btn sos" href="#">SOS</a>
            </div>
    </div>
    <div class="content">
        <div class="container">
            <div class="section" id="formularios">
                <div class="list-content"></div>
            </div>
        </div>
    </div>
</div>

<script>
  import { onMount } from 'svelte'
  
  onMount(() => {
    window.$("#record-def-collection-page").RecordDefsCollectionPage("#formularios");
    console.log("DONE: installed RecordDefsCollectionPage to hash '#formularios'")
  })
</script>
